"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vescovato": {
    "2ce046ae": [{
      "hkey": "176db77e",
      "slug": "vescovato",
      "name": "Vescovato",
      "primary": true,
      "skipSearch": false
    }],
    "ca-de-sfondrati": [{
      "hkey": "176db77e",
      "slug": "vescovato",
      "name": "Vescovato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "717b5264": [{
      "hkey": "176db77e",
      "slug": "vescovato",
      "name": "Vescovato",
      "primary": true,
      "skipSearch": false
    }],
    "ca-de-stefani": [{
      "hkey": "176db77e",
      "slug": "vescovato",
      "name": "Vescovato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;